export const PRIMARY_RED = '#AD2624'
export const PRIMARY_RED_HOVER = '#8F0806'
export const PRIMARY_RED_BORDER = '#A72220'
export const SECONDARY_RED = '#D44B49'
export const SECONDARY_RED_HOVER = '#B62D2B'
export const BACKGROUND_COLOR = '#F1F1F1'
export const WHITE = '#FFFFFF'
export const GREY = '#CCCCCC'
export const LIGHT_GREY = '#7B7B7B'
export const BLACK = '#333333'
export const UPLOAD_COLOR = '#428BCA'
export const UPLOAD_COLOR_BORDER = '#176AB2'
export const SIDEBAR_COLOR = '#1A1A17'
export const TABLE_HEADER_COLOR = '#404040'



// WEBPACK FOOTER //
// ./src/constants/colors.js